import React, { useState } from "react";
import {
  SummaryBarContainer,
  SummaryOpenContainer,
  ToooltipSummaryBar,
  VisibilityContainer,
} from "../pages/Chemistry/StyledChemistryElements";
import { PlayerClubInfoData, PlayerLargeDataText, PlayerLargeDataValue } from "../styled-components/PlayerCard.Styles";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import { CSSObject } from "styled-components";
import PositiveArrow from "../assets/icons/PositiveArrow.png";
import NegativeArrow from "../assets/icons/NegativeArrow.png";

interface SummaryBarProps {
  selectedTeam: number;
  style: CSSObject;
  overallSFScore: number;
  newOverallSFScore?: number;
  avgAge: number;
  newAvgAge?: number;
  isSwapActive: boolean;
  attackContribution: number;
  newAttackContribution?: number;
  newPPDA?: number;
  ppda: number;
  loading: boolean;
}

const SummaryBar: React.FC<SummaryBarProps> = ({
  selectedTeam,
  style,
  overallSFScore,
  newOverallSFScore,
  avgAge,
  newAvgAge,
  isSwapActive,
  attackContribution,
  newAttackContribution,
  newPPDA,
  ppda,
  loading,
}) => {
  const [isSummaryBarOpen, setIsSummaryBarOpen] = useState<boolean>(true);
  return (
    <>
      {selectedTeam > 0 && (
        <SummaryBarContainer style={style} className={`summarybar-container ${isSummaryBarOpen ? "summary-open" : ""}`}>
          <div className="summarybar-item-container">
            <PlayerClubInfoData className="player-descriptive-data">
              <PlayerLargeDataText className="descriptive-text">OVERALL SYSTEM FIT SCORE</PlayerLargeDataText>
              <PlayerLargeDataValue className="descriptive-value">
                {loading ? "--" : isSwapActive ? newOverallSFScore : overallSFScore}
                {isSwapActive && !loading && newOverallSFScore !== overallSFScore && (
                  <span className={newOverallSFScore! - overallSFScore > 0 ? "positive-difference" : "negative-difference"}>
                    <img src={newOverallSFScore! - overallSFScore > 0 ? PositiveArrow : NegativeArrow} alt="" className="sf-arrow" />
                    {newOverallSFScore! - overallSFScore > 0 ? newOverallSFScore! - overallSFScore : overallSFScore - newOverallSFScore!}
                  </span>
                )}
              </PlayerLargeDataValue>
            </PlayerClubInfoData>
            <PlayerClubInfoData className="player-descriptive-data">
              <PlayerLargeDataText className="descriptive-text">OVERALL ATTACK CONTRIBUTION</PlayerLargeDataText>
              <PlayerLargeDataValue className="descriptive-value">
                {loading ? "--" : isSwapActive ? newAttackContribution : attackContribution}
                {isSwapActive && !loading && newAttackContribution !== attackContribution && (
                  <span className={newAttackContribution! - attackContribution > 0 ? "positive-difference" : "negative-difference"}>
                    <img src={newAttackContribution!- attackContribution > 0 ? PositiveArrow : NegativeArrow} alt="" className="sf-arrow" />
                    {newAttackContribution! - attackContribution > 0
                      ? newAttackContribution! - attackContribution
                      : attackContribution - newAttackContribution!}
                  </span>
                )}
              </PlayerLargeDataValue>
            </PlayerClubInfoData>
            <PlayerClubInfoData className="player-descriptive-data">
              <PlayerLargeDataText className="descriptive-text">PPDA</PlayerLargeDataText>
              <PlayerLargeDataValue className="descriptive-value">
                {loading ? "--" : isSwapActive ? newPPDA : ppda}
                {isSwapActive && !loading && newPPDA !== ppda && (
                  <span className={newPPDA! - ppda > 0 ? "negative-difference" : "positive-difference"}>
                    <img src={newPPDA! - ppda > 0 ? NegativeArrow : PositiveArrow} alt="" className="sf-arrow inverted-arrow" />
                    {newPPDA! - ppda > 0
                      ? (newPPDA! - ppda).toFixed(2)
                      :( ppda - newPPDA!).toFixed(2)}
                  </span>
                )}
              </PlayerLargeDataValue>
            </PlayerClubInfoData>
            <PlayerClubInfoData className="player-descriptive-data">
              <PlayerLargeDataText className="descriptive-text">AV. AGE</PlayerLargeDataText>
              <PlayerLargeDataValue className="descriptive-value">
                {loading ? "--" : isSwapActive ? newAvgAge : avgAge}
                {isSwapActive && !loading && newAvgAge !== avgAge && (
                  <span className={newAvgAge! - avgAge > 0 ? "negative-difference" : "positive-difference"}>
                    <img src={newAvgAge! - avgAge > 0 ? NegativeArrow : PositiveArrow} alt="" className="sf-arrow inverted-arrow" />
                    {newAvgAge! - avgAge > 0 ? newAvgAge! - avgAge : avgAge - newAvgAge!}
                  </span>
                )}
              </PlayerLargeDataValue>
            </PlayerClubInfoData>
          </div>
          {/* <VisibilityContainer className="visibility-container" onClick={() => setIsSummaryBarOpen(false)}>
            <VisibilityOffIcon />
          </VisibilityContainer> */}
        </SummaryBarContainer>
      )}
      {!isSummaryBarOpen && selectedTeam > 0 && (
        <SummaryOpenContainer className="summaryopen-container">
          <ToooltipSummaryBar className="tooltip-summary-bar">Squad effect calculator</ToooltipSummaryBar>
          <div onClick={() => setIsSummaryBarOpen(true)}>
            <TableChartOutlinedIcon />
          </div>
        </SummaryOpenContainer>
      )}
    </>
  );
};

export default SummaryBar;
